import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { CommmentsEntity } from '../comments/comments.entity';
import { DevelopmentStatusEntity } from "../developmentpost/developmentpost.entity";
import { PollVotingEntity } from "../poll/poll-voting.entity";
import { PollEntity } from "../poll/poll.entity";
import { PostActivityEntity } from '../post-activity/post-activity.entity';
import { PostActivitySharedEntity } from "../post-activity/Post_activityshared.entity";
import { PostFilesEntity } from '../post-files/post-files.entity';
import { PostTypeEntity } from '../post-type/post-type.entity';
import { ReportEntity } from "../report/report.entity";
import { UserEntity } from "../user/user.entity";
import { VillageEntity } from "../village/village.entity";
import { PostJobsEntity } from "./jobs.entity";
import { PostCategoryEntity } from "./post-category.entity";
import { PostPointsEntity } from "./post-points.entity";

@Entity('post')
export class PostEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("text",{
    nullable: false,
    name:"post_text"
  })
  text:string;
  @Column("int",{
    nullable:false,
    default:0,
    name:"is_development_post"  
  })
  isDevelopmentPost:number;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"develop_status"
  })
  developStatus:string;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"location"
  })
  location:string;
  @Column("int",{
    nullable:true,
    default:null,
    name:"village_id"
  })
  villageId:number;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"view_count"
  })
  viewCount:string;
  @Column("int",{
    nullable: false,
    name:"post_type_id"
  })
  postTypeId:number;
  @Column("int",{
    nullable: false,
    name:"post_category_id"
  })
  postCategoryId:number;
  @Column("int",{
    nullable:false,
    name:"user_id"
  })
  userId:number;
  @Column("datetime", {
    nullable:true,
    name:"poll_expire"
  })
  pollExpire:Date;
  @Column("int",{
    nullable:false,
    default:2,               
    name:"status"
  })
  status:number;
  @Column("boolean", {
    nullable:false,
    default:false,
    name:"is_pinned"
  })
  isPinned:boolean;
  @Column("datetime",{
    nullable:true,
    name:"pin_date"
  })
  pinDate:Date;
  @Column("int", {
    nullable:true,
    name:"pinned_by"
  })
  pinnedBy:number | null;
  @Column("varchar",{
    nullable:true,
    length:100,
    name:'job_mobile'
  })
  jobMobile:string;
  @Column("varchar",{
    nullable: true,
    length:500,
    name:"job_email"
  })
  jobEmail:string;
  @Column("text",{
    nullable: true,
    name:"job_techcatg"
  })
  jobTechCategory:string;
  @Column("date",{
    nullable:true,
    name:"jobexp_dt"
  })
  jobExpDate:string;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  @Column("int", {
    nullable: true,
    name: "created_user"
  })
  createdUser: number | null;
  @UpdateDateColumn({
    name: "updated_at",
    type:'datetime'
  })
  updatedAt: Date;
  @Column("int", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: number | null;
  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(() => PostTypeEntity, (posttype: PostTypeEntity) => posttype.post)
  @JoinColumn({ name: 'post_type_id' })
  posttype: PostTypeEntity;
  @ManyToOne(() => PostCategoryEntity, (postcategory: PostCategoryEntity) => postcategory.post)
  @JoinColumn({ name: 'post_category_id' })
  postcategory: PostCategoryEntity;
  @ManyToOne(() => UserEntity, (user:UserEntity) => user.post)
  @JoinColumn({name:'user_id'})
  user:UserEntity;
  @ManyToOne(()=>VillageEntity,(village:VillageEntity) =>village.post,{ nullable:true, })
  @JoinColumn({name:'village_id'})
  village:VillageEntity;
  @OneToMany(()=>PollEntity,(poll:PollEntity) => poll.post)
  poll:PollEntity;
  @OneToMany(() => PostFilesEntity, (postfiles: PostFilesEntity)=>postfiles.post)
  postfiles: PostFilesEntity;
  @OneToMany(() => PostActivityEntity, (postactivity: PostActivityEntity) => postactivity.post)
  postactivity: PostActivityEntity;
  @OneToMany(() => CommmentsEntity, (comments: CommmentsEntity) => comments.post)
  comments: CommmentsEntity;  
  @OneToMany(() => ReportEntity, (report: ReportEntity) => report.post)
  report: ReportEntity;
  @OneToMany(() => PollVotingEntity, (pollvoting: PollVotingEntity) => pollvoting.post)
  pollvoting:PollVotingEntity;
  @OneToMany(()=>PostPointsEntity, (postpoints:PostPointsEntity) => postpoints.post)
  postpoints:PostPointsEntity;
  @OneToOne(() => DevelopmentStatusEntity, (development: DevelopmentStatusEntity) => development.post)
  development:DevelopmentStatusEntity;

  @OneToMany(() => PostActivitySharedEntity, (postactivityshared: PostActivitySharedEntity) => postactivityshared.post)
  postactivityshared: PostActivitySharedEntity;

  @OneToMany(() => PostJobsEntity, (postjobs: PostJobsEntity) => postjobs.post)
  postjobs: PostJobsEntity;

}

  
